import clsx from "clsx";

import { randomRewardImageUrl } from "@/utils/rewards";

export const Reward = () => {
  return (
    <div className={clsx("flex flex-col gap-4 items-center justify-center")}>
      <img
        src={randomRewardImageUrl()}
        className="w-full h-full max-h-[25svh] aspect-square object-contain rounded-lg ring-4 ring-gray-200"
      />
    </div>
  );
};
